import { Base } from '@studiometa/js-toolkit';
import Slider from '../molecules/Slider.js';
import StickyForm from '../atoms/StickyForm.js';
// import getTrustpilot from '../utils/getTrustpilot.js';

/**
 * FormProduct component
 */
export default class FormProduct extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'FormProduct',
    components: {
      Slider,
      StickyForm,
    },
    refs: [
      'inputId',
      'variants',
      'submit',
      'color[]',
      'size[]',
      'colorname',
      'sizename',
      'submit-label',
      'submit-btn[]',
      'restockmail[]',
      'totalReviews',
      'globalStarsRating',
      'starsContainer',
      'trustScore',
    ],
  };

  /**
   * return the currently selected color
   * @returns {string}
   */
  get currentColor() {
    let color = '';
    this.$refs.color.forEach((elem) => {
      if (elem.checked) {
        color = elem.value;
      }
    });

    return color;
  }

  /**
   * return the currently selected size
   * @returns {string}
   */
  get currentSize() {
    let size = '';
    this.$refs.size.forEach((elem) => {
      if (elem.checked) {
        size = elem.value;
      }
    });

    return size;
  }

  /**
   * Read Variants JSON
   * @returns {JSON}
   */
  get getVariants() {
    return JSON.parse(this.$refs.variants.innerHTML);
  }

  /**
   *  mounted hook
   */
  async mounted() {
    // Retrieve the HTMLElement class from cart-drawer.js
    this.cart = document.querySelector('cart-drawer');

    if (this.$refs.colorname) {
      this.updateColorName();
    }

    if (this.$refs.sizename) {
      this.updateSizeName();
    }

    // this.setStars();

    this.checkAvailability();
    this.changeSlider();
  }

  /**
   * Get the current language
   * @returns {string} String;
   */
  getLanguageFromUrl() {
    const currentUrl = window.location.href;

    // Extract the language from the URL
    const languageRegex = /\/(de|fr|nl)\/?/; // Modify the regex pattern based on your URL structure
    const matches = currentUrl.match(languageRegex);
    return matches ? matches[1] : null;
  }

  /**
   * TODO - Waiting for the trustpilot connexion
   */
  // async setStars() {
  //   // Retrieve the trustpilot score
  //   const apiUrl = `https://api.trustpilot.com/v1/business-units/641ac7df32bc3e5e965392d5`;

  //   const data = await getTrustpilot(apiUrl);
  //   this.$root.score = data.score.trustScore;
  //   this.$root.totalReviews = data.numberOfReviews.total;
  //   this.$refs.totalReviews.innerHTML = this.$root.totalReviews;

  //   // Calc the width of the stars
  //   const starsPercent = (this.$root.score * 100) / 5;
  //   this.$refs.globalStarsRating.style.width = `${starsPercent}%`;
  //   this.$refs.starsContainer.classList.remove('-translate-x-full');
  // }

  /**
   * Update the native hidden input from shopify on change
   * @deprecated this function is useless since the krtbit addons ignore this
   */
  updateHiddenInput() {
    const { id } = this.findProductWithSelectedVariants();
    this.$refs.inputId.value = id;
  }

  /**
   * Check the availability of the variant and update the disabled state if needed
   */
  checkAvailability() {
    const variants = this.getVariants;
    const { preorder } = this.$refs['submit-label'].dataset;

    variants.forEach((variant) => {
      if (variant.option1 === this.currentColor && variant.option2 === this.currentSize) {
        this.updateSizeName(!variant.available);

        if (this.$children.StickyForm.length > 0) {
          this.updateStickyForm();
        }

        // Set buy button to available or out of stock
        if (variant.available) {
          this.$refs['submit-btn'].forEach((btn) => {
            btn.removeAttribute('disabled', variant.available);
          });
        } else {
          this.$refs['submit-btn'].forEach((btn) => {
            btn.setAttribute('disabled', variant.available);
          });
        }
        this.languageFromUrl = this.getLanguageFromUrl();
        if (!preorder) {
          if (this.languageFromUrl === 'de') {
            this.availableLabel = 'In den Warenkorb legen';
            this.soldOutLabel = 'Ausverkauft';
          } else if (this.languageFromUrl === 'nl') {
            this.availableLabel = 'Aan winkelwagen toevoegen';
            this.soldOutLabel = 'Uitverkocht';
          } else {
            this.availableLabel = 'Ajouter au panier';
            this.soldOutLabel = 'Épuisé';
          }
        } else if (this.languageFromUrl === 'de') {
          this.availableLabel = 'Vorbestellung';
          this.soldOutLabel = 'Ausverkauft';
        } else if (this.languageFromUrl === 'nl') {
          this.availableLabel = 'voorbestelling';
          this.soldOutLabel = 'Uitverkocht';
        } else {
          this.availableLabel = 'Précommander';
          this.soldOutLabel = 'Épuisé';
        }
        this.$refs['submit-label'].innerHTML = variant.available
          ? this.availableLabel
          : this.soldOutLabel;
      }

      // Disable size based on availability
      if (variant.option1 === this.currentColor) {
        if (variant.available) {
          const size = document.querySelector(
            `#size-${variant.option2.replaceAll(' ', '-').replaceAll('.', '-')}`,
          );
          const fakeSize = document.querySelector(
            `#fake-size-${variant.option2.replaceAll(' ', '-').replaceAll('.', '-')}`,
          );
          if (size) {
            size.removeAttribute('disabled');
          }
          if (fakeSize) {
            fakeSize.removeAttribute('disabled');
          }
        } else {
          // disabled size who are not available
          const size = document.querySelector(
            `#size-${variant.option2.replaceAll(' ', '-').replaceAll('.', '-')}`,
          );
          const fakeSize = document.querySelector(
            `#fake-size-${variant.option2.replaceAll(' ', '-').replaceAll('.', '-')}`,
          );
          if (size) {
            size.setAttribute('disabled', true);
          }
          if (fakeSize) {
            fakeSize.setAttribute('disabled', true);
          }
        }
      }
    });
  }

  /**
   * Change the active slider base on the current color
   */
  changeSlider() {
    let active = this.$children.Slider.find(({ $el }) => {
      return $el.dataset.color === this.currentColor;
    });

    // Select first element if there is no variants
    if (active === undefined) {
      active = this.$children?.Slider[0] ?? null;
    }

    if (!active) {
      return;
    }

    this.$children.Slider.forEach(({ $el }) => {
      $el.classList.add('opacity-0', 'pointer-events-none', 'hidden');
    });

    active.$el.classList.remove('opacity-0', 'pointer-events-none', 'hidden');

    // Change preview image on the StickyForm
    if (this.$children.StickyForm.length > 0) {
      this.$children.StickyForm[0].$refs.image.setAttribute('srcset', '');
      this.$children.StickyForm[0].$refs.image.setAttribute('src', active.firstImage);
    }
  }

  /**
   * on Color Radio Input Change
   */
  async onColorChange() {
    await this.updateColorName();
    await this.checkAvailability();
    await this.changeSlider();
    this.updateHiddenInput();
  }

  /**
   * Update the color name
   */
  updateColorName() {
    this.$refs.colorname.innerHTML = `· ${this.currentColor}`;
  }

  /**
   * Update Sticky Form Input Values
   */
  updateStickyForm() {
    if (this.$children.StickyForm[0].$refs.size) {
      this.$children.StickyForm[0].$refs.size.value = this.currentSize;
    }
    if (this.$children.StickyForm[0].$refs.color) {
      this.$children.StickyForm[0].$refs.color.value = this.currentColor;
    }
  }

  /**
   * On Size Radio input Change
   */
  async onSizeChange() {
    await this.updateSizeName();
    await this.checkAvailability();
    await this.updateHiddenInput();
  }

  /**
   * update the size name
   * @param {boolean} isOutOfStock
   */
  updateSizeName(isOutOfStock = false) {
    this.languageFromUrl = this.getLanguageFromUrl();
    console.log(this.languageFromUrl);
    if (this.languageFromUrl === 'de') {
      console.log('de');
      this.size = '<span class="font-semibold"> Größe </span> ·';
      this.unavailable = 'nicht verfügbar';
    } else if (this.languageFromUrl === 'nl') {
      console.log('nl');
      this.size = '<span class="font-semibold"> Maat </span> ·';
      this.unavailable = 'niet beschikbaar';
    } else {
      console.log('fr');
      this.size = '<span class="font-semibold"> Taille </span> ·';
      this.unavailable = 'indisponible';
    }
    const outOfStock = isOutOfStock ? this.unavailable : '';
    this.$refs.sizename.innerHTML = `${this.size} ${this.currentSize} ${outOfStock}`;
    console.log(this.size);
  }

  /**
   * on click
   * @param {Event} event
   */
  onRestockmailClick(event) {
    // Simulate click on the out of stock button who is hidden in the front-end;
    document.querySelector('.restock-alerts-notify-button').click();

    const variants = this.getVariants;
    const { size } = event.target.dataset;
    // Retrieve the current variant ID of the out of stock product click based on the size clicked
    const { id } = variants.find((p) => p.option1 === this.currentColor && p.option2 === size);

    setTimeout(() => {
      // assign the value to the select to preselect the correct color/size combination
      const select = document.querySelector('.restock-alerts-variant-select');
      select.value = id;

      // force to trigger the change event on the select otherwise the application script does not send the correct value on the XHR request
      const evt = new Event('change');
      select.dispatchEvent(evt);
    }, 100);
  }

  /**
   * Find the correct product with the selected variants
   * @returns {number}
   */
  findProductWithSelectedVariants() {
    const variants = this.getVariants;

    let product = {};

    if (this.$refs.color.length > 0 && this.$refs.size.length > 0) {
      product = variants.find(
        (p) => p.option1 === this.currentColor && p.option2 === this.currentSize,
      );
    }

    if (this.$refs.color.length > 0 && this.$refs.size.length <= 0) {
      product = variants.find((p) => p.option1 === this.currentColor);
    }

    // if there'is only one variants it's the product
    if (variants.length === 1) {
      [product] = variants;
    }

    return product;
  }

  /**
   * onSubmit
   * @param {Event} event
   */
  onSubmit(event) {
    event.preventDefault();

    const product = this.findProductWithSelectedVariants();

    if (product.available) {
      this.$root.addToCart(product.id);
    } else {
      // @todo snackbar produit indisponible
    }
  }

  /**
   * Sync the Color
   * @param {string} value input value
   */
  onStickyFormSyncColor(value) {
    this.$refs.color.forEach((radio) => {
      const hasChanged = radio.checked !== (radio.value === value);
      if (hasChanged) {
        radio.checked = radio.value === value;
        const event = new Event('change', { bubbles: true });
        radio.dispatchEvent(event);
      }
    });
  }

  /**
   * Sync the Size
   * @param {string} value input value
   */
  onStickyFormSyncSize(value) {
    this.$refs.size.forEach((radio) => {
      const hasChanged = radio.checked !== (radio.value === value);
      if (hasChanged) {
        radio.checked = radio.value === value;
        const event = new Event('change', { bubbles: true });
        radio.dispatchEvent(event);
      }
    });
  }
}
